module.exports = __webpack_public_path__ + "static/tabc-badge-lg-3cf24920c2b90bd2aef077f0a3869c7a.png";